import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        isCurrentPage: false
    },
    mutations: {
        currentPage(state) {
            state.isCurrentPage = true
        },
        notCurrentPage(state) {
            state.isCurrentPage = false
        }
    }
})

export default store